import React from 'react'

import styles from './MultimediaButtonContent.module.css'

const iconStyles = { width: '3.5em', height: '3.5em', color: 'var(--color-text-button-default)' }

export type MultimediaButtonContentProps = {
  Icon: React.FunctionComponent<React.SVGProps<SVGSVGElement>>
  title: string
  subtitle: string
}

const MultimediaButtonContent: React.FC<MultimediaButtonContentProps> = ({ Icon, title, subtitle }) => {
  return (
    <div>
      {Icon && <Icon style={iconStyles} />}
      <div>
        <span className={`font-body-medium-bold font-default-color ${styles.title}`}>{title}</span>
      </div>
      <div>
        <span className={`font-body-small-regular font-default-color ${styles.subtitle}`}>{subtitle}</span>
      </div>
    </div>
  )
}

export default MultimediaButtonContent
